import { httpClient } from './HttpClient';

const url = '/api/odata/v4/Restrictions';

export const RestrictionsApi = {
  getRestrictionByService: (id: number | undefined) => {
    return httpClient.get(url + '/' + (id ?? -1));
  },
};
